import { ChakraProvider, extendTheme } from '@chakra-ui/react';
import * as Sentry from '@sentry/react';
import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { createBrowserRouter, createRoutesFromElements } from 'react-router';
import { RouterProvider } from 'react-router/dom';

import { App } from './App';
import { GlobalError } from './components/GlobalError';
import { initAuthProvider, msalInstance } from './config/authConfig';
import { queryClient } from './config/query-client';
import { AppRoutes } from './config/routes';
import { theme as MWTheme } from './config/theme';
import { ErrorMonitoring } from './services/error-monitoring';

const theme = extendTheme(MWTheme);

ErrorMonitoring.init();

const SentryWrappedApp = () => (
  <Sentry.ErrorBoundary
    fallback={({ resetError }) => <GlobalError onReset={resetError} />}
  >
    <App msalInstance={msalInstance} />
  </Sentry.ErrorBoundary>
);

const router = createBrowserRouter([
  {
    element: <SentryWrappedApp />,
    children: [...createRoutesFromElements(AppRoutes())],
  },
]);

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement,
);

async function main() {
  await initAuthProvider();

  root.render(
    <React.StrictMode>
      <QueryClientProvider client={queryClient}>
        <ChakraProvider theme={theme}>
          <RouterProvider router={router} />
        </ChakraProvider>
        <ReactQueryDevtools buttonPosition="bottom-left" />
      </QueryClientProvider>
    </React.StrictMode>,
  );
}

// eslint-disable-next-line @typescript-eslint/no-floating-promises
main();
